if (!customElements.get('chic-share-qr')) {
  customElements.define('chic-share-qr', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) {
        this.prefetchQR();
        return;
      }
      this.dataset.ready = 'true';
      this.status = this.querySelector('[data-status]');
      this.link = this.querySelector('[data-link]');
      this.querySelector('[data-copy]').hidden = false;
      if (navigator.share) this.querySelector('[data-share]').hidden = false;
      this.prefetchQR();
      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-copy], [data-share], [data-download]');
        if (!button || !this.contains(button)) return;
        if (button.hasAttribute('data-copy')) this.copyLink();
        if (button.hasAttribute('data-share')) this.share(button);
        if (button.hasAttribute('data-download')) {
          event.preventDefault();
          this.download(button);
        }
      });
    }

    announce(message) {
      this.status.textContent = message;
    }

    async copyLink() {
      try {
        if (!navigator.clipboard || !window.isSecureContext) throw new Error('clipboard unavailable');
        await navigator.clipboard.writeText(this.dataset.target);
        this.announce(this.dataset.copied);
      } catch {
        this.link.focus();
        this.link.select();
        this.link.setSelectionRange(0, this.link.value.length);
        this.announce(this.dataset.manual);
      }
    }

    disconnectedCallback() {
      if (this.qrRequest) this.qrRequest.abort();
      this.qrRequest = null;
    }

    prefetchQR() {
      if (!navigator.canShare || this.qrFile || this.qrRequest) return;
      const request = new AbortController();
      this.qrRequest = request;
      fetch(this.dataset.png, { mode: 'cors', signal: request.signal })
        .then((response) => {
          if (!response.ok) throw new Error('image unavailable');
          return response.blob();
        })
        .then((blob) => {
          if (!this.isConnected) return;
          const file = new File([blob], 'CHIC-In-Brazil-QR.png', { type: 'image/png' });
          if (navigator.canShare({ files: [file] })) this.qrFile = file;
        })
        .catch(() => {})
        .finally(() => {
          if (this.qrRequest === request) this.qrRequest = null;
        });
    }

    async share(button) {
      button.disabled = true;
      try {
        const payload = { title: this.dataset.title, text: this.dataset.description, url: this.dataset.target };
        if (this.qrFile) payload.files = [this.qrFile];
        await navigator.share(payload);
        this.announce(this.dataset.shared);
      } catch (error) {
        if (error.name !== 'AbortError') this.announce(this.dataset.shareError);
      } finally {
        button.disabled = false;
      }
    }

    async download(anchor) {
      try {
        const response = await fetch(anchor.href, { mode: 'cors' });
        if (!response.ok) throw new Error('download unavailable');
        const blob = await response.blob();
        const objectUrl = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = objectUrl;
        link.download = anchor.dataset.download;
        document.body.appendChild(link);
        link.click();
        link.remove();
        setTimeout(() => URL.revokeObjectURL(objectUrl), 30000);
        this.announce(this.dataset.downloaded);
      } catch {
        window.location.assign(anchor.href);
      }
    }
  });
}
